import React, { lazy } from 'react';
import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import RootRoute from './RootRoute';
import COHome from '../pages/COHome';
import CoPublicRoutes from './CoPublicRoutes';
import COMainPage from '../pages/COMainPage';

const ClientServerErrorPage = lazy(() => import('../pages/error/ClientServerErrorPage'));
const UnauthorizedErrorPage = lazy(() => import('../pages/error/UnauthorizedErrorPage'));
const NotFoundErrorPage = lazy(() => import('../pages/error/NotFoundErrorPage'));
const ClientChangePersonalInfoPage = lazy(() => import('@bo-pages/co/member/ClientChangePersonalInfoPage'));
// ECMJ - 박준석 : 사용자 상세 (재직/휴직/퇴직 처리). /client/member/member 목록에서 진입
const ClientMemberDetailPage = lazy(() => import('../pages/co/member/ClientMemberDetailPage'));

const PointApprovalManagementPage = lazy(() => import('@bo-pages/point/PointApprovalManagementPage'));
const PointMemberSaveInfoPage = lazy(() => import('@bo-pages/point/PointMemberSaveInfoPage'));
const OrderInformationPage = lazy(() => import('@bo-pages/co/order/CoOrderInformationPage'));
const AccApiHistoryPage = lazy(() => import('@bo-pages/co/member/AccApiHistoryPage'));

const CoMemberPage = lazy(() => import('@bo-pages/co/member/CoMemberPage'));
// ECMJ - 박준석 : 휴/퇴직자 목록 (상세는 공용 ClientMemberDetailPage 사용)
const LeaveRetiredManagementPage = lazy(() => import('@bo-pages/co/member/LeaveRetiredManagementPage'));
const CoMemberPotinPage = lazy(() => import('@bo-pages/co/member/CoMemberPointPage'));

const CoRoutes = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" element={<RootRoute />}>
      <Route path="" element={<COHome />} errorElement={<ClientServerErrorPage />}>
        <Route path="" element={<COMainPage />} />
        <Route path="client">
          <Route path="point">
            <Route path="point-approval-management" element={<PointApprovalManagementPage />} />
            <Route path="member-save-info" element={<PointMemberSaveInfoPage />} />
          </Route>
          <Route path="order">
            <Route path="order-info" element={<OrderInformationPage />} />
          </Route>
          <Route path="member">
            <Route path="change-personal-info" element={<ClientChangePersonalInfoPage />} />
            <Route path="acc-api-history" element={<AccApiHistoryPage />} />
            <Route path="member" element={<CoMemberPage />} />
            <Route path="member/:memberNumber" element={<ClientMemberDetailPage />} /> {/* ECMJ - 박준석 */}
            <Route path="leave-retired-management" element={<LeaveRetiredManagementPage />} /> {/* ECMJ - 박준석 */}
            <Route path="point" element={<CoMemberPotinPage />} />
          </Route>
        </Route>
      </Route>
      <Route path="client/*" element={<CoPublicRoutes />} />
      <Route path="unauthorized" element={<UnauthorizedErrorPage />} />
      <Route path="not-found" element={<NotFoundErrorPage />} />
      <Route path="error" element={<ClientServerErrorPage />} />
      <Route path="*" element={<NotFoundErrorPage />} />
    </Route>
  )
);

export default CoRoutes;
